import React, { useState, useEffect } from "react"
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalBody,
  ModalHeader,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import Breadcrumbs from "components/Common/Breadcrumb"
import ManageTeamFilter from "./manageTeamFilter"
import { getTeamLookup, getTeams, onUpdateTeams } from "store/createTeam/action"
import moment from "moment"
import "./manageteamstoggle.scss"
import Accordian from "./accordian"
import NavTabs from "./NavTabs"
import ManageTeamForms from "../component/ManageteamModal"
import { DateValue } from "./manageTeamscols"

const Manage_Team = props => {
  const dispatch = useDispatch()
  const [filtersubCategory, setfiltersubCategory] = useState([])
  const [selectedUserData, setuserList] = useState(null)
  const [selectedSubcategory, setselectedSubcategory] = useState(null)
  const [selectedMainCategory, setselectedMainCategory] = useState(null)
  const [selectedReport, setselectedReport] = useState(null)
  const [selectedSupervisor, setselectedSupervisor] = useState(null)
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [activeTab, setActiveTab] = useState("2")
  const [selectedData, setselectedData] = useState({})
  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [showUserTable, setshowUserTable] = useState(false)
  const [accordionSelectedData, setaccordionSelectedData] = useState({})
  const [supervised, setsupervised] = useState(false)
  const [reported, setreported] = useState(false)
  const [selectedid, setselectedid] = useState(null)
  const [accordianColumn, setAccordianColumn] = useState(false)
  // Server-side pagination for the "All Others" tab (tab "3"), which otherwise loads every team.
  const PAGE_SIZE = 20
  const [pageIndex, setPageIndex] = useState(0)

  // Get company ID from user Login
  const userid = JSON.parse(localStorage.getItem("authUser") || "{}")?.data?.id

  // Handle API Call
  useEffect(() => {
    dispatch(getTeamLookup())
  }, [])
  //Handle to get value from Redux
  const {
    teamList,
    getTeamsData,
    approvesuccess,
    endTeamSuccess,
    rejectsuccess,
    companySetting,
    accessSetting,
    updateteams,
    updateteamsapprove,
  } = useSelector(state => ({
    teamList: state?.createteam?.createTeamLookupList,
    getTeamsData: state?.createteam?.responseTeam,
    approvesuccess: state?.createteam?.approveTeam?.statusCode,
    rejectsuccess: state?.createteam?.rejectTeam?.statusCode,
    endTeamSuccess: state?.createteam?.endTeam,
    companySetting: state?.Login?.userDetails?.data,
    accessSetting: state?.Login?.accessDetails?.data,
    updateteams: state?.createteam?.updateteamsnoapprove,
    updateteamsapprove: state?.createteam?.updateteams?.statusCode,
  }))
  
  const accessgroupname = JSON.parse(localStorage.getItem("authUser") || "{}")
    ?.data?.accessgroupname
  const hideAccessAllOthersbutton = accessSetting?.accessAllTeam
  // Admins (or users granted accessAllTeam) can approve any team, so their Approval tab loads the
  // whole organisation's pending teams instead of only teams they personally supervise/report to.
  const canApproveAllTeams =
    accessgroupname === "Admin" || accessSetting?.accessAllTeam === true

  useEffect(() => {
    const userId = (selectedUserData || []).map(item => item.userId)
    const isAllOthers = activeTab === "3"
    const params = {
      // "All Others" lists every approved team, so it must not be scoped to the admin's own userId.
      userId: isAllOthers ? 0 : userid,
      categoryid: selectedMainCategory?.id,
      subcategoryid: selectedSubcategory?.id,
      reporttoid: selectedReport?.accessGroupid,
      supervisorid: selectedSupervisor?.userId,
      startDate: startDate
        ? moment(new Date(startDate)).format("YYYY-MM-DD")
        : "",
      endDate: endDate ? moment(new Date(endDate)).format("YYYY-MM-DD") : "",
      excludesupervisorid: activeTab == "1" ? userid : 0,
      useridList: userId,
      // Only "All Others" paginates server-side; other tabs keep the legacy full load.
      approved: isAllOthers ? true : undefined,
      pagesize: isAllOthers ? PAGE_SIZE : 0,
      pagenumber: isAllOthers ? 1 : 0,
    }
    if (activeTab == "1") {
      console.log("")
    } else {
      if (isAllOthers) setPageIndex(0)
      dispatch(getTeams(params))
    }
  }, [
    selectedMainCategory,
    selectedSubcategory,
    selectedReport,
    selectedSupervisor,
    selectedUserData,
    startDate,
    endDate,
  ])

  useEffect(() => {
    // const userId = (selectedUserData || []).map(item => item.userId)
    const isAllOthers = activeTab === "3"
    const isApprovalAllForAdmin = activeTab === "1" && canApproveAllTeams
    const params = {
      userId: isAllOthers || isApprovalAllForAdmin ? 0 : userid,
      categoryid: 0,
      subcategoryid: 0,
      reporttoid: 0,
      supervisorid: 0,
      startDate: "",
      endDate: "",
      useridList: [],
      // Admins approving across the org load all pending teams (userId 0, no self-exclusion).
      excludesupervisorid:
        activeTab == "1" ? (canApproveAllTeams ? 0 : userid) : 0,
      // Reload the current page for "All Others" so an edit/approve does not re-load every team.
      approved: isAllOthers ? true : undefined,
      pagesize: isAllOthers ? PAGE_SIZE : 0,
      pagenumber: isAllOthers ? pageIndex + 1 : 0,
    }
    if (rejectsuccess === 200) {
      dispatch(getTeams(params))
    }
    if (approvesuccess == 200) {
      dispatch(getTeams(params))
    }
    if (updateteamsapprove === 200) {
      dispatch(getTeams(params))
    }
    if (updateteams?.message === "UnApprovedTeam Updated Successfull") {
      dispatch(getTeams(params))
    }
    if (endTeamSuccess?.message === "EndDate successfully updated!") {
      dispatch(getTeams(params))
    }
  }, [
    approvesuccess,
    endTeamSuccess,
    rejectsuccess,
    updateteams,
    updateteamsapprove,
  ])
  const userColumns = React.useMemo(() => {
    const result = [
      {
        Header: "Transaction Date",
        accessor: "createdDate",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => {
          return <DateValue {...cellProps} />
        },
      },

      {
        Header: "Start Date",
        disableFilters: true,
        accessor: "startDate",
        filterable: true,
        Cell: cellProps => {
          return <DateValue {...cellProps} />
        },
      },
      {
        Header: "End Date",
        accessor: "endDate",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => {
          return <DateValue {...cellProps} />
        },
      },
    ]
    return result
  }, [])

  // handle Main Category
  const categoryFilter = value => {
    setselectedMainCategory(value)
    setselectedSubcategory(null)
  }
  // handle report data
  const reportfilter = value => {
    setselectedReport(value)
  }
  const supervisorfilter = value => {
    setselectedSupervisor(value)
  }
  // handle Sub-category
  const subcategoryFilter = value => {
    setselectedSubcategory(value)
  }

  //handle selectedUserData
  const userListFilter = value => {
    setuserList(value)
  }

  //Filter sub-categoryDrop-down
  useEffect(() => {
    const filteredData = selectedMainCategory?.id
      ? teamList?.subCategoryLookup?.filter(
          el => el?.categoryId === selectedMainCategory?.id
        )
      : teamList?.subCategoryLookup
    setfiltersubCategory(filteredData)
  }, [selectedMainCategory])

  useEffect(() => {
    setfiltersubCategory(teamList?.subCategoryLookup)
  }, [teamList])

  const handleCancel = () => {
    if (modal) {
      setModal(false)
    } else {
      setModal(true)
    }
  }
  const toggle = () => {
    if (modal) {
      setModal(false)
    } else {
      setModal(true)
    }
  }
  // Fetch a specific page of the "All Others" list, preserving the active dropdown filters.
  const handleAllOthersPage = newPage => {
    if (newPage < 0) return
    setPageIndex(newPage)
    const userId = (selectedUserData || []).map(item => item.userId)
    dispatch(
      getTeams({
        userId: 0,
        categoryid: selectedMainCategory?.id,
        subcategoryid: selectedSubcategory?.id,
        reporttoid: selectedReport?.accessGroupid,
        supervisorid: selectedSupervisor?.userId,
        startDate: startDate
          ? moment(new Date(startDate)).format("YYYY-MM-DD")
          : "",
        endDate: endDate ? moment(new Date(endDate)).format("YYYY-MM-DD") : "",
        excludesupervisorid: 0,
        useridList: userId,
        approved: true,
        pagesize: PAGE_SIZE,
        pagenumber: newPage + 1,
      })
    )
  }

  const checkboxFilter = data => {
    if (supervised && reported) {
      return (
        data.supervisorid === userid ||
        data.teamMembers[0].reportToId === userid
      )
    } else if (reported) {
      return data.teamMembers[0].reportToId === userid
    } else if (supervised) {
      return data.supervisorid === userid
    } else {
      return data
    }
  }

  return (
    <React.Fragment>
      <div className="page-content" id="manageTeams">
        <Container fluid>
          <Row>
            <Col xs="12">
              <Breadcrumbs
                title={"Manage Team"}
                breadcrumbItem={"Manage Team"}
              />
              <Row className="mb-4">
                <NavTabs
                  setActiveTab={setActiveTab}
                  activeTab={activeTab}
                  userid={userid}
                  setselectedData={setselectedData}
                  selectedUserData={selectedUserData}
                  selectedData={selectedData}
                  selectedReport={selectedReport}
                  getTeamsData={getTeamsData}
                  supervisorfilter={supervisorfilter}
                  selectedSupervisor={selectedSupervisor}
                  setuserList={setuserList}
                  setselectedSubcategory={setselectedSubcategory}
                  setselectedMainCategory={setselectedMainCategory}
                  setselectedReport={setselectedReport}
                  setStartDate={setStartDate}
                  setEndDate={setEndDate}
                  setselectedSupervisor={setselectedSupervisor}
                  setshowUserTable={setshowUserTable}
                  setsupervised={setsupervised}
                  setreported={setreported}
                  setAccordianColumn={setAccordianColumn}
                  hideAccessAllOthersbutton={hideAccessAllOthersbutton}
                  hideapprove={accessgroupname === "Supervisor"}
                  setPageIndex={setPageIndex}
                  pageSize={PAGE_SIZE}
                  canApproveAllTeams={canApproveAllTeams}
                />
              </Row>
              <Card>
                <CardBody>
                  <ManageTeamFilter
                    teamList={teamList}
                    userListFilter={userListFilter}
                    selectedUserData={selectedUserData}
                    setStartDate={setStartDate}
                    setEndDate={setEndDate}
                    startDate={startDate}
                    endDate={endDate}
                    categoryFilter={categoryFilter}
                    selectedMainCategory={selectedMainCategory}
                    subcategoryFilter={subcategoryFilter}
                    selectedSubcategory={selectedSubcategory}
                    filtersubCategory={filtersubCategory}
                    reportfilter={reportfilter}
                    supervisorfilter={supervisorfilter}
                    selectedSupervisor={selectedSupervisor}
                    selectedReport={selectedReport}
                    buttonname="Manage Team"
                    activeTab={activeTab}
                    selectedData={selectedData}
                    setsupervised={setsupervised}
                    supervised={supervised}
                    setreported={setreported}
                    reported={reported}
                    companySetting={companySetting}
                  />
                </CardBody>
              </Card>
              <Card>
                <CardBody>
                  <h5>Teams</h5>
                  {getTeamsData?.data
                    .filter(el =>
                      activeTab === "1"
                        ? el.approved === false
                        : activeTab === "3"
                        ? el.approved === true
                        : checkboxFilter(el)
                    )
                    .map(item => {
                      return (
                        <Accordian
                          key={`${item.categoryid}_${item.subcategoryid}_${item.supervisorid}`}
                          item={item}
                          activeTab={activeTab}
                          loginuserid={userid}
                          setselectedData={setselectedData}
                          setStartDate={setStartDate}
                          setIsEdit={setIsEdit}
                          toggle={toggle}
                          setshowUserTable={setshowUserTable}
                          setaccordionSelectedData={setaccordionSelectedData}
                          accordionSelectedData={accordionSelectedData}
                          showUserTable={showUserTable}
                          userColumns={userColumns}
                          setselectedid={setselectedid}
                          selectedid={selectedid}
                          keyId={`${item.categoryid}_${item.subcategoryid}_${item.supervisorid}`}
                          setAccordianColumn={setAccordianColumn}
                          accordianColumn={accordianColumn}
                          companySetting={companySetting}
                        />
                      )
                    })}
                  {getTeamsData?.data?.filter(el =>
                    activeTab === "1"
                      ? el.approved === false
                      : activeTab === "3"
                      ? el.approved === true
                      : checkboxFilter(el)
                  )?.length == 0 ? (
                    <div className="d-flex justify-content-center">
                      No Teams Matches for the Selected Combinations
                    </div>
                  ) : (
                    ""
                  )}
                  {activeTab === "3" &&
                    getTeamsData?.totalcount > 0 &&
                    (() => {
                      const total = getTeamsData.totalcount
                      const totalPages = Math.ceil(total / PAGE_SIZE)
                      const from = pageIndex * PAGE_SIZE + 1
                      const to = Math.min((pageIndex + 1) * PAGE_SIZE, total)
                      const windowSize = 5
                      let end = Math.min(totalPages, pageIndex + 3)
                      let start = Math.max(0, end - windowSize)
                      end = Math.min(totalPages, start + windowSize)
                      const pages = []
                      for (let i = start; i < end; i++) pages.push(i)
                      return (
                        <div className="d-flex justify-content-between align-items-center flex-wrap mt-3">
                          <div className="text-muted">
                            Showing {from}–{to} of {total} teams
                          </div>
                          <Pagination className="mb-0">
                            <PaginationItem disabled={pageIndex === 0}>
                              <PaginationLink
                                previous
                                href="#"
                                onClick={e => {
                                  e.preventDefault()
                                  handleAllOthersPage(pageIndex - 1)
                                }}
                              />
                            </PaginationItem>
                            {pages.map(p => (
                              <PaginationItem key={p} active={p === pageIndex}>
                                <PaginationLink
                                  href="#"
                                  onClick={e => {
                                    e.preventDefault()
                                    handleAllOthersPage(p)
                                  }}
                                >
                                  {p + 1}
                                </PaginationLink>
                              </PaginationItem>
                            ))}
                            <PaginationItem
                              disabled={pageIndex >= totalPages - 1}
                            >
                              <PaginationLink
                                next
                                href="#"
                                onClick={e => {
                                  e.preventDefault()
                                  handleAllOthersPage(pageIndex + 1)
                                }}
                              />
                            </PaginationItem>
                          </Pagination>
                        </div>
                      )
                    })()}
                  {modal && (
                    <Modal isOpen={modal} toggle={toggle} size="xl">
                      <ModalHeader toggle={toggle} tag="h4">
                        {"Edit Manage Team"}
                      </ModalHeader>
                      <ModalBody>
                        <ManageTeamForms
                          filtersubCategory={filtersubCategory}
                          toggle={toggle}
                          selectedData={selectedData}
                          handleCancel={handleCancel}
                          setfiltersubCategory={setfiltersubCategory}
                          startDate={startDate}
                          teamList={teamList}
                          setStartDate={setStartDate}
                          setselectedData={setselectedData}
                          isEdit={isEdit}
                          companySetting={companySetting}
                          onUpdateTeams={onUpdateTeams}
                          isDisable={accessgroupname === "Supervisor"}
                          setModal={setModal}
                        />
                      </ModalBody>
                    </Modal>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Manage_Team
